import React, { Component } from 'react';
import { Row, Col, Button, Container } from 'reactstrap';
import { Link } from 'react-router-dom';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';

import checkAstronowLogo from './../../../assets/images/Logo.png'
import checkAstroLogo from './../../../assets/images/checkAstroLogo.png'
import './style.css';
class TarotHoroscrpe extends Component {


    render() {
        let countryCode = JSON.parse(sessionStorage.getItem('countryCode'));
        let url=window.location.host;
        return (
            <Container>
                <Row>
                    <Col className="tarot-horoscope">
                        <div className="tarot-horoscope-bg">
                            <div>
                                <img src={url.indexOf('checkastronow')>=0? checkAstronowLogo:checkAstroLogo} className={url.indexOf('checkastronow')>=0? "logo":"checkastro-logo"}/>
                                <p className={"tarot-horoscope-heading-p"}><FormattedMessage id="main.tarothoroscope.title"
                                    defaultMessage="Measure the peace of planets of through expert advice"
                                    description=""
                                    values="" />
                                </p>
                                <p className={countryCode.countryCode==="nl" ? "tarot-bg-p":null}><FormattedMessage id="main.tarothoroscope.subtitle"
                                    defaultMessage="We are ready to tell what stars have prepared for you or your family."
                                    description=""
                                    values="" />
                                </p>
                                <div className="tarot-horoscope-button-section">
                                    <a href="#horoscope-reading"><Button onClick={this.handleTarotReading} outline className="tarot-horoscope-btn">
                                        <span className="tarot-horoscope-text">
                                        <FormattedMessage id="main.tarothoroscope.horoscopebutton"
                                            defaultMessage="HOROSCOPES"
                                            description=""
                                            values="" />
                                        </span>
                                            </Button></a>
                                        <a href="#tarot-reading"><Button onClick={this.handleTarotReading} outline className="tarot-horoscope-btn">
                                        <span className="tarot-horoscope-text">
                                        <FormattedMessage id="main.tarothoroscope.tarotbutton"
                                            defaultMessage="TAROT READING"
                                            description=""
                                            values="" />
                                        </span>
                                            </Button></a>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        )
    }
}
export default TarotHoroscrpe;


// WEBPACK FOOTER //
// ./src/checkastronow/components/screens/TarotHoroscrpe/tarotHoroscrpe.js